import Layout from "@/admin/js/layout/index.vue";

const iBotStatisticRoutes = {
    name: 'iBotStatistic',
    path: '/i-bot-statistic',
    component: Layout,
    meta: { title: '',  noCache: false },
    redirect: '',
    children: [
        {
            name: 'iBotStatisticList',
            path:'',
            component: () => import('@/admin/js/views/ibot-statistic/index'),
            meta: {title: 'Копии iBot'}
        }

    ],
}
export default iBotStatisticRoutes;
